import React from 'react';
import IconBox from '../../shared/components/IconBox';
import ScrollingText from '../../shared/components/ScrollingText';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as DragHandleIcon } from '../../assets/icons/dragHandle.svg';

const Tab = ({
  site,
  dragHandleProps,
  onSelect = () => {},
  hideDrag = false,
  compact = false,
  disableLabelHint = false,
  previewEnabled = false,
  onPreviewChange = () => {},
  onPreviewClear = () => {}
}) => {
  const { website } = useParams();
  const activeWebsite = parseInt(website, 10);
  const isSelected = site.website === activeWebsite;
  const navigate = useNavigate();

  return (
    <div className="site-nav-item-row"
         {...(!hideDrag ? dragHandleProps : {})}>
      {!hideDrag && (
      <span className="site-nav-item__drag drag drag-handle">
        <DragHandleIcon
          className="icon xs drag-handle-icon" />
      </span>
      )}

      <div className={`site-nav-item ${isSelected ? 'selected-box' : 'unselected-box'}${compact ? ' site-nav-item--compact' : ''}` }
           data-collapsed-label={disableLabelHint ? undefined : site.website}
           title={compact && !disableLabelHint ? site.website : undefined}
           onMouseEnter={previewEnabled && !disableLabelHint
             ? (event) => onPreviewChange(site.website, event, isSelected)
             : undefined}
           onMouseLeave={previewEnabled ? onPreviewClear : undefined}
           onClick={() => {
             onSelect();
             navigate('/dashboard/site/' + site.website);
            }}>
        <IconBox website={site.website} />
        <span className="nav-item__text site-nav-item__label">
          <ScrollingText text={site.website} />
        </span>
      </div>
    </div>
  );
};

export default Tab;
